export const USER_DEFINITIONS = "/User/GetUsers"
export const USER_DEFINITIONS_BY_USERNAME = "/User/GetUsersByUserName"
export const USER_INSERT = "/User/InsertUser"
export const USER_UPDATE = "/User/UpdateUser"
export const USER_DELETE = "/User/DeleteUser"
export const USER_CREATE = "/UserAcount/CreateUserAcount"
export const USER_CONFIRM = "/UserAcount/ConfirmUserAcount"
export const CHECK_DUPLICATE_USER = "/User/CheckDuplicateUser"
export const GENERATE_PASSWORD = "/User/CreatePassword"
export const GENERATE_CLIENT_ID = "/Authentication/GenerateClientId"
export const GENERATE_CLIENT_SECRET = "/Authentication/GenerateClientSecret"
export const INSERT_USER_KEYS = "/User/InsertUserKeysAuthentication"
export const GET_USER_BY_USERNAME = "/User/GetUserByUserNameAuthentication"
export const GET_USER_BY_USERNAME_SYNC = "/User/GetUserByUserNameAuthentication"
export const GET_USERENCKEY_BY_MERCHANTGUID="/User/GetUserByMerchantGuidAuthentication"
export const GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID="/User/GetUserByMerchantGuidAuthentication"
export const GET_API_KEY_BY_MERCHANT_ID="/User/GetUserByMerchantIdAuthentication"




